// src/admin/Register.js
import React, { useState,useEffect } from 'react';
import { Container, TextField, Button, Typography, MenuItem, Box,Card,
  CardContent, Table,TableBody,TableCell,TableContainer,TableHead,TableRow,IconButton,Chip,InputAdornment,Paper} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import SearchIcon from "@mui/icons-material/Search";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import axios from 'axios';
import './Register.css'; // Custom styles for background
import BASE_URL from '../config';
const userTypes = [
  { id: 1, label: 'Super Admin' },
  { id: 2, label: 'Admin' },
  { id: 3, label: 'Staff' }
];

const Register = () => {
    const navigate = useNavigate();
 /*    const [formData, setFormData] = useState({
        userType: 'admin', // Default selection for admin
        userTypeId: 2,
        fullName: '',
        email: '',
        password: '',
        mobile: ''
    }); */
    const [errors, setErrors] = useState({});
    const [editMode, setEditMode] = useState(false);
const [editId, setEditId] = useState(null);

const initialForm = {
    userType: "admin",
    userTypeId: 2,
    fullName: "",
    email: "",
    password: "",
    mobile: "",
    isActive: 1
};

const [formData, setFormData] = useState(initialForm);
    const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "userType") {
      const selected = userTypes.find(u => u.label.toLowerCase() === value.toLowerCase());
      setFormData({ ...formData, userType: value, userTypeId: selected?.id });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

const [users, setUsers] = useState([]);
const [search, setSearch] = useState("");
useEffect(() => {
    fetchUsers();

}, []);
    // Validate form inputs
    const validateForm = () => {
        const validationErrors = {};
        // Full name validation (only characters)
        if (!/^[a-zA-Z\s]+$/.test(formData.fullName)) {
            validationErrors.fullName = 'Full name should contain only letters';
        }
        // Email validation
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            validationErrors.email = 'Enter a valid email';
        }
        // Password validation (8 characters, 1 uppercase, 1 special char, 1 digit)
        if (!/^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(formData.password)) {
            validationErrors.password = 'Password must be 8 characters, contain 1 uppercase, 1 digit, and 1 special character';
        }
        // Mobile validation
        if (!/^\d{10}$/.test(formData.mobile)) {
            validationErrors.mobile = 'Enter a valid 10-digit mobile number';
        }
        setErrors(validationErrors);
        return Object.keys(validationErrors).length === 0;
    };
    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        // If form validation fails, do not proceed
        if (!validateForm()) return;
        try {

             if(editMode){

await axios.put(

`${BASE_URL}/api/users/${editId}`,

{

...formData

}

);

alert("Updated Successfully");

setEditMode(false);

setEditId(null);

setFormData(initialForm);

fetchUsers();

return;

}


            // Check if email exists
            const response = await axios.post(`${BASE_URL}/api/check-email`, { email: formData.email });
            if (response.data.exists) {
                setErrors({ email: 'This email is already registered' });
                return;
            }
            // Hash password (this is typically done on the backend, but for simplicity, assume it's hashed)
            const hashedPassword = formData.password; // Replace with actual hash logic
             await axios.post(`${BASE_URL}/api/register`, {
        userTypeId: formData.userTypeId,
        userType: formData.userType,
        fullName: formData.fullName,
        email: formData.email,
        //password: formData.password,
        password: hashedPassword,
        mobile: formData.mobile
      });
            // Redirect to admin login page
            navigate('/admin/login');
        } catch (error) {
            console.error('Registration error:', error);
        }
    };
    const fetchUsers = async () => {
    try {

         console.log("Fetching Users...");
        const res = await axios.get(`${BASE_URL}/api/users`);
        console.log("Response", res);

        console.log("Data", res.data);

        setUsers(res.data);
    } catch (err) {

        console.log(err);

    }
};

const filteredUsers = users.filter((u) => {

    const text = search.toLowerCase();

    return (

        (u.Full_Name || "")
            .toLowerCase()
            .includes(text)

        ||

        (u.Email || "")
            .toLowerCase()
            .includes(text)

        ||

        (u.Mobile || "")
            .toString()
            .includes(text)

        ||

        (u.User_type || "")
            .toLowerCase()
            .includes(text)

    );

});
const handleEdit=(user)=>{

window.scrollTo({

top:0,

behavior:"smooth"

});

setEditMode(true);

setEditId(user.Reg_Id);

setFormData({

userType:user.User_type,

userTypeId:user.User_type_Id,

fullName:user.Full_Name,

email:user.Email,

password:"",

mobile:user.Mobile,

isActive:user.IsActive

});

};

const handleDelete=async(id)=>{

const ok=window.confirm(

"User is deleting record.\n\nThis action cannot be retrieved.\n\nContinue?"

);

if(!ok) return;

try{

await axios.delete(

`${BASE_URL}/api/users/${id}`

);

alert("Deleted Successfully");

fetchUsers();

}

catch(err){

alert("Unable to delete");

}

}
    return (
        <div className="register-page">
            <div className="register-container">
               {/*  <Container maxWidth="xs" sx={{ marginTop: 4 }}> */}
               <Container maxWidth="lg" sx={{ marginTop: 4 }}>
                    <Typography variant="h5" component="h1" gutterBottom>
                        Admin Registration
                    </Typography>
                    <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
                        {/* User Type - Admin is default */}
                                    <TextField
              select
              label="User Type"
              fullWidth
              value={formData.userType}
              name="userType"
              onChange={handleChange}
              margin="normal"
            >
              {userTypes.map((u) => (
                <MenuItem key={u.id} value={u.label.toLowerCase()}>
                  {u.label}
                </MenuItem>
              ))}
            </TextField>

                        {/* Full Name */}
                        <TextField
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            label="Full Name"
                            name="fullName"
                            value={formData.fullName}
                            onChange={handleChange}
                            error={!!errors.fullName}
                            helperText={errors.fullName}
                        />
                        {/* Email */}
                        <TextField
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            label="Email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            error={!!errors.email}
                            helperText={errors.email}
                        />
                        {/* Password */}
                        <TextField
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            label="Password"
                            type="password"
                            name="password"
                            value={formData.password}
                            onChange={handleChange}
                            error={!!errors.password}
                            helperText={errors.password}
                        />
                        {/* Mobile */}
                        <TextField
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            label="Mobile Number"
                            name="mobile"
                            value={formData.mobile}
                            onChange={handleChange}
                            error={!!errors.mobile}
                            helperText={errors.mobile}
                        />

{editMode && (

<FormControlLabel
control={
<Checkbox
checked={formData.isActive===1}
onChange={(e)=>
setFormData({
...formData,
isActive:e.target.checked?1:0
})
}
/>
}
label="Active User"
/>

)}


                        {/* Register Button */}
                        <Button type="submit" variant="contained" fullWidth 
                        >
                            {/* Register */}
                            {editMode ? "Update User" : "Register"}
                        </Button>
                    </Box>
                    <Box sx={{ mt:4, mb:2 }}>

<TextField

fullWidth

placeholder="Search Name / Email / Mobile"

value={search}

onChange={(e)=>setSearch(e.target.value)}

InputProps={{

startAdornment:(

<InputAdornment position="start">

<SearchIcon/>

</InputAdornment>

)

}}

/>

</Box>

<Card
sx={{
mt:3,
borderRadius:3,
boxShadow:5
}}
>

<CardContent>

<Typography
variant="h6"
sx={{
mb:2,
fontWeight:"bold",
color:"#0d47a1"
}}
>

Registered Users

</Typography>

<TableContainer
component={Paper}
sx={{
maxHeight:500
}}
>

<Table stickyHeader>

<TableHead>

<TableRow>

<TableCell
sx={{
fontWeight:"bold",
background:"#1565c0",
color:"#fff"
}}
>

SL No

</TableCell>

<TableCell
sx={{
fontWeight:"bold",
background:"#1565c0",
color:"#fff"
}}
>

User Type

</TableCell>

<TableCell
sx={{
fontWeight:"bold",
background:"#1565c0",
color:"#fff"
}}
>

Full Name

</TableCell>

<TableCell
sx={{
fontWeight:"bold",
background:"#1565c0",
color:"#fff"
}}
>

Email

</TableCell>

<TableCell
sx={{
fontWeight:"bold",
background:"#1565c0",
color:"#fff"
}}
>

Mobile

</TableCell>

<TableCell
align="center"
sx={{
fontWeight:"bold",
background:"#1565c0",
color:"#fff"
}}
>

Status

</TableCell>

<TableCell
align="center"
sx={{
fontWeight:"bold",
background:"#1565c0",
color:"#fff"
}}
>

Actions

</TableCell>

</TableRow>

</TableHead>

<TableBody>

{

filteredUsers.length===0 ?

(

<TableRow>

<TableCell
colSpan={7}
align="center"
>

No Users Found

</TableCell>

</TableRow>

)

:

filteredUsers.map((user,index)=>(

<TableRow
key={user.Reg_Id}
hover
>

<TableCell>

{index+1}

</TableCell>

<TableCell>

{user.User_type}

</TableCell>

<TableCell>

{user.Full_Name}

</TableCell>

<TableCell>

{user.Email}

</TableCell>

<TableCell>

{user.Mobile}

</TableCell>

<TableCell
align="center"
>

<Chip

label={

user.IsActive==1

?

"Active"

:

"Inactive"

}

color={

user.IsActive==1

?

"success"

:

"error"

}

size="small"

/>

</TableCell>

<TableCell
align="center"
>

<IconButton
color="primary"
onClick={()=>handleEdit(user)}
>
<EditIcon/>
</IconButton>

<IconButton

color="error"
onClick={()=>handleDelete(user.Reg_Id)}
>
<DeleteIcon/>

</IconButton>

</TableCell>

</TableRow>

))

}

</TableBody>

</Table>

</TableContainer>

</CardContent>

</Card>
                </Container>
            </div>
        </div>
        
    );
};
export default Register;
